const joinClassNames = (...args: string[]) => args.filter(Boolean).join(' ');

export default joinClassNames;
